import { selectFromUserInviteDto } from '../../models';

export default selectFromUserInviteDto()
  .id
  .uuid
  .organization((o) => o.name)
  .role((r) => r.name)
  .invitingUser((u) => u.fullname)
  .email
  .isDriverInvite
  .inviteStatusId
  .toString();
